import { render, staticRenderFns } from "./items.component.vue?vue&type=template&id=3fab8649&scoped=true&"
import script from "./items.component.vue?vue&type=script&lang=ts&"
export * from "./items.component.vue?vue&type=script&lang=ts&"
import style0 from "./items.component.vue?vue&type=style&index=0&id=3fab8649&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fab8649",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VIcon,VTextField,VTooltip})
